import { getTexts } from '../imports'
import strings from './localized.json'

export default locale => getTexts(strings)[locale]



// WEBPACK FOOTER //
// ./src/features/ServerMenu/localization/index.js